module.exports = __webpack_public_path__ + "static/media/paybox.291aade2.png";